import React from "react";
import { Icon } from "antd";
import className from "classnames";

import FilterJob from "./filterJob";

import { $util } from "../../../../../helper";

import "../style/sliderFunc.scss";

class SliderFunc extends React.Component {
  state = {
    openState: true,
    showContent: true,
  };

  changeOpenState = () => {
    const { openState } = this.state;
    if (openState) {
      this.setState({
        openState: !openState,
        showContent: false,
      });
    } else {
      this.setState({
        openState: !openState,
      });
    }
  };

  handleOnTransitionEnd = $util.debounce(() => {
    if (this.state.openState) {
      this.setState({
        showContent: true,
      });
    }
  }, 10);

  render() {
    const { openState, showContent } = this.state;
    const { positionCategory, teamEnum, workCity } = this.props;

    return (
      <div
        className={className(
          "sliderFunc",
          openState ? "sliderFunc--open" : "sliderFunc--close",
          showContent ? "sliderFunc--showContent" : "sliderFunc--hideContent"
        )}
        onTransitionEnd={this.handleOnTransitionEnd}
      >
        <FilterJob
          {...{ positionCategory, teamEnum, workCity }}
          className={className(
            showContent
              ? "sliderFunc__content--show"
              : "sliderFunc__content--hidden"
          )}
        />
        <div
          className={className(
            "sliderFunc__icon",
            showContent ? "sliderFunc__icon--open" : "sliderFunc__icon--close"
          )}
          onClick={this.changeOpenState}
        >
          {showContent ? <Icon type="left" /> : <Icon type="right" />}
        </div>
      </div>
    );
  }
}

export default SliderFunc;



// WEBPACK FOOTER //
// ./src/components/formList/gameForm/jobSelect/sliderFunc/index.js